export const linksSelector = state => state.lgpdLinks
